import URLSearchParams from 'url-search-params';
import { parentWindow } from './constants';
import apiConfig from 'utils/apiConfig';

export default function postMessage(type) {
  const parentDomain = parentWindow.domain;
  if (parentDomain) {
    const content = document.getElementById('app');
    window.parent.postMessage(
      { type: type || 'RESIZE', value: content.offsetHeight },
      parentDomain
    );
  }
}

export function updateParentDomain() {
  const query = new URLSearchParams(location.search);
  const parentDomain = query.get('parentDomain');
  parentWindow.domain = parentDomain;
}

export function updateCellcaptiveId() {
  const query = new URLSearchParams(location.search);
  const cellcaptiveId = query.get('cellcaptiveId') || apiConfig.cellcaptiveId;
  parentWindow.cellcaptiveId = cellcaptiveId;
}



// WEBPACK FOOTER //
// ./app/utils/postMessage.js